import {
  Button,
  ButtonGroup,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "react-bootstrap";

export default function createNew() {
  return (
    <>
      <Dropdown as={ButtonGroup}>
        <DropdownToggle variant="danger" id="dropdown-split-basic">
          Create New
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem href="/show">Create Show</DropdownItem>
          <DropdownItem href="/ticket">Create Ticket Group Code</DropdownItem>
          <DropdownItem href="/seat-plan">Create Seat Plan</DropdownItem>
          <DropdownItem href="/ticket-prices">Create Ticket Prices</DropdownItem>
          <DropdownItem href="/buy-link">Create Buy Links</DropdownItem>
          <DropdownItem href="/news-media">Create News & Media</DropdownItem>
          <DropdownItem href="/video">Create Video</DropdownItem>
          <DropdownItem href="/gallery">Create Albums</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </>
  );
}
